import { OnDestroy, Injectable } from '@angular/core';
import { Dexie } from 'dexie';

import { Eorder } from '../models/eorder';

class DbEntryOffer {
	constructor(
		readonly offer: string
	) {}
}

@Injectable({ providedIn: 'root' })
export class EorderWizardDb extends Dexie implements OnDestroy {
	private static readonly OFFER_ID = 0;
	declare private readonly offers: Dexie.Table<DbEntryOffer, number>;

	constructor() {
		super('offerWizard');
		this.version(1).stores({
			offers: ',offer'
		});

		this.offers.mapToClass(DbEntryOffer);
	}

	ngOnDestroy() {
		this.close();
	}

	async saveEorder(eorder: Eorder) {
		return this.offers.put(
			new DbEntryOffer(JSON.stringify(eorder)),
			EorderWizardDb.OFFER_ID
		);
	}

	async getOffer() {
		const entry = await this.offers.get(EorderWizardDb.OFFER_ID);
		if (!entry) {
			return undefined;
		}
		return <Eorder> JSON.parse(entry.offer);
	}

	async removeOffer() {
		return this.offers.delete(EorderWizardDb.OFFER_ID);
	}
}
